import { Injectable } from '@angular/core';

export class WebStorageService {
  static count = 0;
  id: number;

  enableLogs = false;

  constructor(protected storage: Storage) {
    this.id = WebStorageService.count;
    WebStorageService.count++;
  }

  get<T = any>(key: string): T {
    const value = this.storage.getItem(key);
    this.log('get ' + key + ': ' + value);

    if (!!value) {
      return JSON.parse(value);
    } else {
      return value as T;
    }
  }

  getRaw(key: string): any {
    return this.storage.getItem(key);
  }

  private log(message: string): void {
    if (this.enableLogs) {
      console.log('#' + this.id + ': ' + message);
    }
  }

  set(key: string, value: any): void {
    const stringValue =
      typeof value === 'string' ? value : JSON.stringify(value);
    this.log('set ' + key + ' to ' + stringValue);
    this.storage.setItem(key, stringValue);
  }

  remove(key: string): void {
    if (this.has(key)) {
      this.log('remove ' + key + ': ' + this.get(key));
      this.storage.removeItem(key);
    }
  }

  has(key: string): boolean {
    const hasKey = !!this.storage.getItem(key);
    this.log('has ' + key + ': ' + (hasKey ? 'yes' : 'no'));
    return hasKey;
  }

  clear(): void {
    this.storage.clear();
  }
}

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService extends WebStorageService {
  constructor() {
    super(localStorage);
  }
}

export class SessionStorageService extends WebStorageService {
  constructor() {
    super(sessionStorage);
  }
}
